import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-73c45faf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "notifications" }
const _hoisted_2 = { class: "inner" }
const _hoisted_3 = { class: "list" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 0,
  class: "item__action"
}

import { inject, ref, onMounted, Ref } from 'vue'

import { injectionKeys } from '@/constants/injectionKeys'

import {
  GetYmNotificationResponseItem,
  SetYmNotificationViewRequest,
} from '@/models/ApiIF'

import AppCheckbox from '@/components/AppCheckbox/AppCheckbox.vue'
import SlotModal from '@/components/SlotModal/SlotModal.vue'
import ApiHelper from '@/helpers/ApiHelper'
import { useHandleError } from '@/composables/useHandleError'

interface Props {
  notifications: GetYmNotificationResponseItem[]
}

type NotificationForDisplay = GetYmNotificationResponseItem & {
  isHide: number
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Notifications',
  props: {
    notifications: null
  },
  emits: ['close'],
  setup(__props: any, { emit }) {

const props = __props as {
  notifications: GetYmNotificationResponseItem[]
}

/**
 * Notifications.
 *
 * お知らせモーダル.
 */

const isUserId = inject<Ref<boolean>>(injectionKeys.isUserId)!
const { handleErrors } = useHandleError()




const notificationList = ref<NotificationForDisplay[]>([])

// 「次回から表示しない」のチェックの切り替え
const onChangeSelected = (notificationId: number) => {
  const notification = notificationList.value.find(
    (item) => item.notificationId === notificationId
  )
  if (!notification) return
  notification.isHide = Number(!notification.isHide)
}

// モーダルを閉じるとき
const onClickClose = () => {
  emit('close')

  if (!isUserId) return
  setYmNotification()
}

onMounted(() => {
  notificationList.value = props.notifications.map((notification) => ({
    ...notification,
    isHide: 0,
  }))
})

// ↓ 主にTF様の編集領域
// ------------------------------

// Yomokka!お知らせ表示設定
const setYmNotification = () => {
  // 非表示対象のお知らせIDを取得
  const targetNotificationIds = notificationList.value
    .filter((notification) => {
      return notification.isHide
    })
    .map((notification) => {
      return notification.notificationId
    })
  // 非表示対象が無いときはリクエストしない
  if (targetNotificationIds.length === 0) return

  const req: SetYmNotificationViewRequest = {
    notificationIds: targetNotificationIds,
  }

  ApiHelper.setYmNotificationView(req).catch((err) => {
    handleErrors(err)
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SlotModal, {
    loading: false,
    keyboard: false,
    onClose: onClickClose
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("ul", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(notificationList.value, (item) => {
              return (_openBlock(), _createElementBlock("li", {
                key: item.notificationId,
                class: "item"
              }, [
                _createElementVNode("div", {
                  class: "item__main",
                  innerHTML: item.notification
                }, null, 8, _hoisted_4),
                (_unref(isUserId))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createVNode(AppCheckbox, {
                        class: "item__checkbox",
                        name: "notification",
                        displayName: "つぎから<ruby><rb>表示</rb><rt>ひょうじ</rt></ruby>しない",
                        checked: Boolean(item.isHide),
                        onChange: ($event: any) => (onChangeSelected(item.notificationId))
                      }, null, 8, ["checked", "onChange"])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})